import type { MapViewState } from "../types";
import { encodeMapState } from "./urlState";

export async function shareView(view: MapViewState): Promise<"shared" | "copied"> {
  const url = new URL(window.location.href);
  url.hash = encodeMapState(view);
  url.search = "";
  if (navigator.share) {
    await navigator.share({ title: "مپینو", url: url.toString() });
    return "shared";
  }
  await navigator.clipboard.writeText(url.toString());
  return "copied";
}
